/**
 * Translate supplier/internal print labels to customer-facing labels.
 */

import { derivedOptionLabel } from '@/lib/product-options/derived-option-labels';

export const printLabelTranslations: Record<string, Record<string, string>> = {
  nl: {
    'Afmetingen': 'Afmetingen',
    'Personalisatie': 'Personalisatie',
    "Extra's": "Extra's",
    'Product': 'Product',
    'Materiaal': 'Materiaal',
    'Afwerking': 'Afwerking',
    'Bedrukking': 'Bedrukking',
    'Levering': 'Levering',
    'Kies je formaat': 'Kies je formaat',
    'Formaat': 'Formaat',
    'Waar komt het canvas te hangen?': 'Waar komt het canvas te hangen?',
    'Omlijsting': 'Omlijsting',
    'Frame': 'Frame',
    'Ophangen': 'Ophangen',
    'Urgentie': 'Levertijd',
    'Levertijd': 'Levertijd',
    'Liggend': 'Liggend',
    'Staand': 'Staand',
    'Vierkant': 'Vierkant',
    'Eigen formaat': 'Eigen formaat',
    'Voor binnen': 'Voor binnen',
    'Voor buiten': 'Voor buiten',
    'Standaard 18 mm': 'Standaard 18 mm',
    'Premium 38 mm': 'Premium 38 mm',
    'Ophangsysteem meegeleverd': 'Ophangsysteem meegeleverd',
    'Extra stevig ophangsysteem': 'Extra stevig ophangsysteem',
    'Standaard': 'Standaard',
    'Snel': 'Snel',
    'Spoed': 'Spoed',
    'Dagje eerder': 'Dagje eerder',
    'Duurzaam': 'Duurzaam',
    'Aantal': 'Aantal',
    'Beschermlaag': 'Beschermlaag',
    'Beschermende coating (glans)': 'Beschermende coating (glans)',
    'Beschermende coating (mat)': 'Beschermende coating (mat)',
    'Boorgaten': 'Boorgaten',
    'Boorgaten in elke hoek (6 mm)': 'Boorgaten in elke hoek (6 mm)',
    'Boorgaten in elke hoek (8 mm)': 'Boorgaten in elke hoek (8 mm)',
    'Boorgaten in elke hoek (9 mm)': 'Boorgaten in elke hoek (9 mm)',
    'Boorgaten in elke hoek (10 mm)': 'Boorgaten in elke hoek (10 mm)',
    '1 boorgat': '1 boorgat',
    '2 boorgaten': '2 boorgaten',
    '3 boorgaten': '3 boorgaten',
    '4 boorgaten': '4 boorgaten',
    '5 boorgaten': '5 boorgaten',
    '6 boorgaten': '6 boorgaten',
    '7 boorgaten': '7 boorgaten',
    '8 boorgaten': '8 boorgaten',
    '9 boorgaten': '9 boorgaten',
    '10 boorgaten': '10 boorgaten',
    'Hoeken afronden': 'Hoeken afronden',
    '350 g/m² Airtex®': 'Premium fotobehang',
    '320 g/m² Kavalan Gecko': 'PVC-vrij premium behang',
    '3 mm Dibond Budget': 'Dibond standaard 3 mm',
    '3 mm Dibond® Premium': 'Dibond premium 3 mm',
    '4 mm Dibond Budget': 'Dibond extra stevig 4 mm',
    '6 mm Dibond Budget': 'Dibond extra dik 6 mm',
    '3 mm Plexiglas transparant': 'Plexiglas helder 3 mm',
    '5 mm Plexiglas transparant': 'Plexiglas premium 5 mm',
    '10 mm Plexiglas transparant': 'Plexiglas extra dik 10 mm',
    '3 mm Dibond geborsteld aluminium (horizontaal)': 'Geborsteld aluminium 3 mm - horizontale borstelrichting',
    '3 mm Dibond geborsteld aluminium (verticaal)': 'Geborsteld aluminium 3 mm - verticale borstelrichting',
    'Full colour (enkelzijdig)': 'Full colour (enkelzijdig)',
    'Full colour (dubbelzijdig)': 'Full colour (dubbelzijdig)',
    'Zwart-wit (enkelzijdig)': 'Zwart-wit (enkelzijdig)',
    'Zwart-wit (dubbelzijdig)': 'Zwart-wit (dubbelzijdig)',
    'Onbedrukt': 'Onbedrukt',
    '4/0 Full colour': 'Full colour (enkelzijdig)',
    '4/4 Full colour': 'Full colour (dubbelzijdig)',
    '4/0': 'Full colour (enkelzijdig)',
    '4/4': 'Full colour (dubbelzijdig)',
    '1/0': 'Zwart-wit (enkelzijdig)',
    '1/1': 'Zwart-wit (dubbelzijdig)',
    'material': 'Materiaal',
    'finish': 'Afwerking',
    'fold': 'Vouw',
    'spot_finish': 'Speciale afwerking voorkant',
    'spot_finish_back': 'Speciale afwerking achterkant',
    'finish_all_around': 'Ophanging',
    'all_sides_equal_finish': 'Afwerking randen',
    'finish_left': 'Linkerkant',
    'finish_right': 'Rechterkant',
    'finish_top': 'Bovenkant',
    'finish_bottom': 'Onderkant',
    'application_side': 'Waar plak je de sticker?',
    'poster_fold': 'Afwerking',
    'print_position': 'Bedrukking',
    'Geen': 'Geen',
    'Geen laminaat': 'Geen beschermlaag',
    'Oraguard® 200 (monomeer glans)': 'Glanzende beschermlaag',
    'Oraguard® 200 (monomeer mat)': 'Matte beschermlaag',
    'Oraguard® 215 (polymeer glans)': 'Glanzende beschermlaag',
    'Oraguard® 215 (polymeer mat)': 'Matte beschermlaag',
    'Enkelzijdig glanslaminaat': 'Glanzende beschermlaag',
    'Enkelzijdig matlaminaat': 'Matte beschermlaag',
    'Dubbelzijdig glanslaminaat': 'Glanzende beschermlaag beide zijden',
    'Dubbelzijdig matlaminaat': 'Matte beschermlaag beide zijden',
    'Enkelzijdig softtouch matlaminaat': 'Softtouch voorkant',
    'Dubbelzijdig softtouch matlaminaat': 'Softtouch beide zijden',
    'Buitenzijde': 'Aan de buitenkant',
    'Binnenzijde (bestand in spiegelbeeld aanleveren)': 'Aan de binnenkant van glas',
    'Gekkotex': 'Gekkotex textielbehang',
    'Orajet® 3162 (monomeer wit)': 'Orajet® 3162 witte monomeerfolie',
    'Orajet® 3162 (monomeer transparant)': 'Orajet® 3162 transparante monomeerfolie',
    'DOT folie (wit)': 'DOT folie wit',
    'Roughmark™ 285 (polymeer wit)': 'Roughmark™ 285 witte polymeerfolie',
    '510 g/m² Frontlit banner': '510 g/m² Frontlit banner',
    '610 g/m² Blockout banner': '610 g/m² Blockout banner',
    '270 g/m² Mesh banner': '270 g/m² Mesh banner',
    '190 g/m² PES Outdoor': '190 g/m² PES Outdoor',
    '135 g/m² gesatineerd mc': '135 g/m² gesatineerd mc',
    '250 g/m² gesatineerd mc': '250 g/m² gesatineerd mc',
    '170 g/m² silk mc': '170 g/m² silk mc',
    '250 g/m² silk mc': '250 g/m² silk mc',
    '160 g/m² ongestreken premium hoogwit': '160 g/m² ongestreken premium hoogwit',
    '230 g/m² mat gestreken premium': '230 g/m² mat gestreken premium',
    '115 g/m² gesatineerd mc': '115 g/m² gesatineerd mc',
    '300 g/m² gesatineerd mc': '300 g/m² gesatineerd mc',
    '350 g/m² gesatineerd mc': '350 g/m² gesatineerd mc',
    '400 g/m² gesatineerd mc': '400 g/m² gesatineerd mc',
    'Standaard posterpapier': '135 g/m² gesatineerd mc',
    'Extra stevig posterpapier': '250 g/m² gesatineerd mc',
    'Zijdeglans posterpapier': '170 g/m² silk mc',
    'Premium zijdeglans posterpapier': '250 g/m² silk mc',
    'Mat premium papier': '160 g/m² ongestreken premium hoogwit',
    'Premium mat posterpapier': '230 g/m² mat gestreken premium',
    '80 g/m² hvo bankpost wit': '80 g/m² HVO bankpost wit',
    'Ringen op de hoeken': 'Ringen op de hoeken',
    'Ringen om de 30 cm': 'Ringen elke 30 cm',
    'Ringen om de 50 cm': 'Ringen elke 50 cm',
    'Zomen en ringen om de 30 cm': 'Zoom en ringen elke 30 cm',
    'Voor alle zijden gelijk': 'Alle randen gelijk',
    'Per zijde verschillend': 'Randen apart kiezen',
    'Schoonsnijden': 'Recht afgesneden',
    'Contoursnijden': 'Op vorm gesneden',
    'Vouwen naar A4': 'Gevouwen naar A4',
    'Plano leveren (opgerold)': 'Ongevouwen opgerold',
    'Plano geleverd': 'Ongevouwen leveren',
    'Gevouwen geleverd': 'Gevouwen leveren',
    '0/0': 'Onbedrukt',
  },
  de: {
    'Afmetingen': 'Maße',
    'Personalisatie': 'Personalisierung',
    "Extra's": 'Extras',
    'Product': 'Produkt',
    'Materiaal': 'Material',
    'Afwerking': 'Verarbeitung',
    'Bedrukking': 'Bedruckung',
    'Levering': 'Lieferung',
    'Kies je formaat': 'Format wählen',
    'Formaat': 'Format',
    'Waar komt het canvas te hangen?': 'Wo soll die Leinwand hängen?',
    'Omlijsting': 'Rahmen',
    'Frame': 'Rahmen',
    'Ophangen': 'Aufhängung',
    'Urgentie': 'Lieferzeit',
    'Levertijd': 'Lieferzeit',
    'Liggend': 'Querformat',
    'Staand': 'Hochformat',
    'Vierkant': 'Quadratisch',
    'Eigen formaat': 'Eigenes Format',
    'Voor binnen': 'Für innen',
    'Voor buiten': 'Für außen',
    'Standaard 18 mm': 'Standard 18 mm',
    'Premium 38 mm': 'Premium 38 mm',
    'Ophangsysteem meegeleverd': 'Aufhängesystem inklusive',
    'Extra stevig ophangsysteem': 'Extra stabiles Aufhängesystem',
    'Standaard': 'Standard',
    'Snel': 'Schnell',
    'Spoed': 'Express',
    'Dagje eerder': 'Einen Tag früher',
    'Duurzaam': 'Nachhaltig',
    'Aantal': 'Anzahl',
    'Beschermlaag': 'Schutzschicht',
    'Beschermende coating (glans)': 'Schutzbeschichtung glänzend',
    'Beschermende coating (mat)': 'Schutzbeschichtung matt',
    'Oraguard® 215 (polymeer glans)': 'Oraguard® 215 glänzend',
    'Oraguard® 215 (polymeer mat)': 'Oraguard® 215 matt',
    'Boorgaten': 'Bohrlöcher',
    'Boorgaten in elke hoek (6 mm)': 'Bohrlöcher in jeder Ecke (6 mm)',
    'Boorgaten in elke hoek (8 mm)': 'Bohrlöcher in jeder Ecke (8 mm)',
    'Boorgaten in elke hoek (9 mm)': 'Bohrlöcher in jeder Ecke (9 mm)',
    'Boorgaten in elke hoek (10 mm)': 'Bohrlöcher in jeder Ecke (10 mm)',
    '1 boorgat': '1 Bohrloch',
    '2 boorgaten': '2 Bohrlöcher',
    '3 boorgaten': '3 Bohrlöcher',
    '4 boorgaten': '4 Bohrlöcher',
    '5 boorgaten': '5 Bohrlöcher',
    '6 boorgaten': '6 Bohrlöcher',
    '7 boorgaten': '7 Bohrlöcher',
    '8 boorgaten': '8 Bohrlöcher',
    '9 boorgaten': '9 Bohrlöcher',
    '10 boorgaten': '10 Bohrlöcher',
    'Hoeken afronden': 'Ecken abrunden',
    '350 g/m² Airtex®': 'Premium-Fototapete',
    '320 g/m² Kavalan Gecko': 'PVC-freie Premium-Tapete',
    '3 mm Dibond Budget': 'Dibond Standard 3 mm',
    '3 mm Dibond® Premium': 'Dibond Premium 3 mm',
    '4 mm Dibond Budget': 'Dibond extra stabil 4 mm',
    '6 mm Dibond Budget': 'Dibond extra dick 6 mm',
    '3 mm Plexiglas transparant': 'Klares Acrylglas 3 mm',
    '5 mm Plexiglas transparant': 'Premium-Acrylglas 5 mm',
    '10 mm Plexiglas transparant': 'Extra dickes Acrylglas 10 mm',
    '3 mm Dibond geborsteld aluminium (horizontaal)': 'Gebürstetes Aluminium 3 mm - horizontale Bürstung',
    '3 mm Dibond geborsteld aluminium (verticaal)': 'Gebürstetes Aluminium 3 mm - vertikale Bürstung',
    'Full colour (enkelzijdig)': 'Vollfarbig (einseitig)',
    'Full colour (dubbelzijdig)': 'Vollfarbig (beidseitig)',
    'Zwart-wit (enkelzijdig)': 'Schwarz-Weiß (einseitig)',
    'Zwart-wit (dubbelzijdig)': 'Schwarz-Weiß (beidseitig)',
    'Onbedrukt': 'Unbedruckt',
    '4/0 Full colour': 'Vollfarbig (einseitig)',
    '4/4 Full colour': 'Vollfarbig (beidseitig)',
    '4/0': 'Vollfarbig (einseitig)',
    '4/4': 'Vollfarbig (beidseitig)',
    '1/0': 'Schwarz-Weiß (einseitig)',
    '1/1': 'Schwarz-Weiß (beidseitig)',
    'material': 'Material',
    'finish': 'Verarbeitung',
    'fold': 'Falz',
    'spot_finish': 'Spezialveredelung Vorderseite',
    'spot_finish_back': 'Spezialveredelung Rückseite',
    'finish_all_around': 'Aufhaengung',
    'all_sides_equal_finish': 'Randverarbeitung',
    'finish_left': 'Linke Seite',
    'finish_right': 'Rechte Seite',
    'finish_top': 'Oben',
    'finish_bottom': 'Unten',
    'application_side': 'Wo klebst du den Aufkleber?',
    'poster_fold': 'Verarbeitung',
    'print_position': 'Druckposition',
    'Geen': 'Keine',
    'Geen laminaat': 'Keine Schutzschicht',
    'Enkelzijdig glanslaminaat': 'Glänzende Schutzschicht',
    'Enkelzijdig matlaminaat': 'Matte Schutzschicht',
    'Dubbelzijdig glanslaminaat': 'Glänzende Schutzschicht beidseitig',
    'Dubbelzijdig matlaminaat': 'Matte Schutzschicht beidseitig',
    'Enkelzijdig softtouch matlaminaat': 'Softtouch Vorderseite',
    'Dubbelzijdig softtouch matlaminaat': 'Softtouch beidseitig',
    'Buitenzijde': 'Außen kleben',
    'Binnenzijde (bestand in spiegelbeeld aanleveren)': 'Innen an Glas kleben',
    'Gekkotex': 'Gekkotex Textiltapete',
    'Orajet® 3162 (monomeer wit)': 'Orajet® 3162 weiße monomere Folie',
    'Orajet® 3162 (monomeer transparant)': 'Orajet® 3162 transparente monomere Folie',
    'DOT folie (wit)': 'Weiße DOT-Folie',
    'Roughmark™ 285 (polymeer wit)': 'Roughmark™ 285 weiße Polymerfolie',
    '510 g/m² Frontlit banner': '510 g/m² Frontlit banner',
    '610 g/m² Blockout banner': '610 g/m² Blockout-Banner',
    '270 g/m² Mesh banner': '270 g/m² Mesh banner',
    '190 g/m² PES Outdoor': '190 g/m² PES Outdoor',
    '135 g/m² gesatineerd mc': '135 g/m² Gesatineerd mc',
    '250 g/m² gesatineerd mc': '250 g/m² Gesatineerd mc',
    '170 g/m² silk mc': '170 g/m² Silk mc',
    '250 g/m² silk mc': '250 g/m² Silk mc',
    '160 g/m² ongestreken premium hoogwit': '160 g/m² Premiumweiß ungestrichen',
    '230 g/m² mat gestreken premium': '230 g/m² Premium matt gestrichen',
    '115 g/m² gesatineerd mc': '115 g/m² Gesatineerd mc',
    '300 g/m² gesatineerd mc': '300 g/m² Gesatineerd mc',
    '350 g/m² gesatineerd mc': '350 g/m² Gesatineerd mc',
    '400 g/m² gesatineerd mc': '400 g/m² Gesatineerd mc',
    '80 g/m² hvo bankpost wit': '80 g/m² HVO Bankpost weiß',
    'Ringen op de hoeken': 'Ösen an den Ecken',
    'Ringen om de 30 cm': 'Ösen alle 30 cm',
    'Ringen om de 50 cm': 'Ösen alle 50 cm',
    'Zomen en ringen om de 30 cm': 'Saum und Ösen alle 30 cm',
    'Voor alle zijden gelijk': 'Alle Raender gleich',
    'Per zijde verschillend': 'Raender einzeln wählen',
    'Schoonsnijden': 'Gerade geschnitten',
    'Contoursnijden': 'In Form geschnitten',
    'Vouwen naar A4': 'Auf A4 gefaltet',
    'Plano leveren (opgerold)': 'Ungefaltet gerollt',
    'Plano geleverd': 'Ungefaltet liefern',
    'Gevouwen geleverd': 'Gefaltet liefern',
    '0/0': 'Unbedruckt',
  },
  fr: {
    'Afmetingen': 'Dimensions',
    'Personalisatie': 'Personnalisation',
    "Extra's": 'Extras',
    'Product': 'Produit',
    'Materiaal': 'Matériau',
    'Afwerking': 'Finition',
    'Bedrukking': 'Impression',
    'Levering': 'Livraison',
    'Kies je formaat': 'Choisissez votre format',
    'Formaat': 'Format',
    'Waar komt het canvas te hangen?': 'Où sera accrochée la toile ?',
    'Omlijsting': 'Cadre',
    'Frame': 'Cadre',
    'Ophangen': 'Accrochage',
    'Urgentie': 'Délai de livraison',
    'Levertijd': 'Délai de livraison',
    'Liggend': 'Paysage',
    'Staand': 'Portrait',
    'Vierkant': 'Carré',
    'Eigen formaat': 'Format personnalisé',
    'Voor binnen': 'Pour intérieur',
    'Voor buiten': 'Pour extérieur',
    'Standaard 18 mm': 'Standard 18 mm',
    'Premium 38 mm': 'Premium 38 mm',
    'Ophangsysteem meegeleverd': 'Système d’accrochage inclus',
    'Extra stevig ophangsysteem': 'Système d’accrochage renforcé',
    'Standaard': 'Standard',
    'Snel': 'Rapide',
    'Spoed': 'Express',
    'Dagje eerder': 'Un jour plus tôt',
    'Duurzaam': 'Durable',
    'Aantal': 'Quantité',
    'Beschermlaag': 'Couche de protection',
    'Hoeken afronden': 'Coins arrondis',
    '350 g/m² Airtex®': 'Papier peint photo premium',
    '320 g/m² Kavalan Gecko': 'Papier peint premium sans PVC',
    '3 mm Dibond Budget': 'Dibond standard 3 mm',
    '3 mm Dibond® Premium': 'Dibond premium 3 mm',
    '4 mm Dibond Budget': 'Dibond renforcé 4 mm',
    '6 mm Dibond Budget': 'Dibond extra épais 6 mm',
    '3 mm Plexiglas transparant': 'Plexiglas transparent 3 mm',
    '5 mm Plexiglas transparant': 'Plexiglas premium 5 mm',
    '10 mm Plexiglas transparant': 'Plexiglas extra épais 10 mm',
    '3 mm Dibond geborsteld aluminium (horizontaal)': 'Aluminium brossé 3 mm - brossage horizontal',
    '3 mm Dibond geborsteld aluminium (verticaal)': 'Aluminium brossé 3 mm - brossage vertical',
    'Full colour (enkelzijdig)': 'Couleur complète (recto)',
    'Full colour (dubbelzijdig)': 'Couleur complète (recto-verso)',
    'Zwart-wit (enkelzijdig)': 'Noir et blanc (recto)',
    'Zwart-wit (dubbelzijdig)': 'Noir et blanc (recto-verso)',
    'Onbedrukt': 'Non imprimé',
    '4/0 Full colour': 'Couleur complète (recto)',
    '4/4 Full colour': 'Couleur complète (recto-verso)',
    '4/0': 'Couleur complète (recto)',
    '4/4': 'Couleur complète (recto-verso)',
    '1/0': 'Noir et blanc (recto)',
    '1/1': 'Noir et blanc (recto-verso)',
    '0/0': 'Non imprimé',
  },
  en: {
    'Afmetingen': 'Dimensions',
    'Personalisatie': 'Personalisation',
    "Extra's": 'Extras',
    'Product': 'Product',
    'Materiaal': 'Material',
    'Afwerking': 'Finish',
    'Bedrukking': 'Printing',
    'Levering': 'Delivery',
    'Kies je formaat': 'Choose your size',
    'Formaat': 'Size',
    'Waar komt het canvas te hangen?': 'Where will the canvas hang?',
    'Omlijsting': 'Frame',
    'Frame': 'Frame',
    'Ophangen': 'Hanging',
    'Urgentie': 'Delivery time',
    'Levertijd': 'Delivery time',
    'Liggend': 'Landscape',
    'Staand': 'Portrait',
    'Vierkant': 'Square',
    'Eigen formaat': 'Custom size',
    'Voor binnen': 'For indoor use',
    'Voor buiten': 'For outdoor use',
    'Standaard 18 mm': 'Standard 18 mm',
    'Premium 38 mm': 'Premium 38 mm',
    'Ophangsysteem meegeleverd': 'Hanging system included',
    'Extra stevig ophangsysteem': 'Extra strong hanging system',
    'Standaard': 'Standard',
    'Snel': 'Fast',
    'Spoed': 'Rush',
    'Dagje eerder': 'One day earlier',
    'Duurzaam': 'Sustainable',
    'Aantal': 'Quantity',
    'Beschermlaag': 'Protective coating',
    'Hoeken afronden': 'Rounded corners',
    '350 g/m² Airtex®': 'Premium photo wallpaper',
    '320 g/m² Kavalan Gecko': 'PVC-free premium wallpaper',
    '3 mm Dibond Budget': 'Standard Dibond 3 mm',
    '3 mm Dibond® Premium': 'Premium Dibond 3 mm',
    '4 mm Dibond Budget': 'Extra sturdy Dibond 4 mm',
    '6 mm Dibond Budget': 'Extra thick Dibond 6 mm',
    '3 mm Plexiglas transparant': 'Clear acrylic glass 3 mm',
    '5 mm Plexiglas transparant': 'Premium acrylic glass 5 mm',
    '10 mm Plexiglas transparant': 'Extra thick acrylic glass 10 mm',
    '3 mm Dibond geborsteld aluminium (horizontaal)': 'Brushed aluminium 3 mm - horizontal grain',
    '3 mm Dibond geborsteld aluminium (verticaal)': 'Brushed aluminium 3 mm - vertical grain',
    'Full colour (enkelzijdig)': 'Full colour (single-sided)',
    'Full colour (dubbelzijdig)': 'Full colour (double-sided)',
    'Zwart-wit (enkelzijdig)': 'Black & white (single-sided)',
    'Zwart-wit (dubbelzijdig)': 'Black & white (double-sided)',
    'Onbedrukt': 'Unprinted',
    '4/0 Full colour': 'Full colour (single-sided)',
    '4/4 Full colour': 'Full colour (double-sided)',
    '4/0': 'Full colour (single-sided)',
    '4/4': 'Full colour (double-sided)',
    '1/0': 'Black & white (single-sided)',
    '1/1': 'Black & white (double-sided)',
    '0/0': 'Unprinted',
  },
};

const wallDecorOptionTranslations: Record<string, Record<string, string>> = {
  de: {
    'Formaat (b x h)': 'Format (B x H)',
    'Papiersoort': 'Papiersorte',
    'Dikte': 'Staerke',
    'Dibond variant': 'Dibond-Variante',
    'Papier': 'Papier',
    'Stof': 'Stoff',
    'Breedte (cm)': 'Breite (cm)',
    'Hoogte (cm)': 'Hoehe (cm)',
    'Breedte per baan': 'Breite pro Bahn',
    'Baanmarkering': 'Bahnmarkierung',
    'Handleiding meeleveren': 'Anleitung beilegen',
    'Aantal banen': 'Anzahl Bahnen',
    'Aantal rollen': 'Anzahl Rollen',
    'Productietijd': 'Produktionszeit',
    'Vorm': 'Form',
    'Hoeken': 'Ecken',
    'Afgeronde hoeken': 'Abgerundete Ecken',
    'Lijst': 'Rahmen',
    'Passe-partout': 'Passepartout',
    'Penseelrichting': 'Buerstrichtung',
    'Coating': 'Beschichtung',
    'coating': 'Beschichtung',
    'Ophanging': 'Aufhaengung',
    'Op maat': 'Nach Mass',
    'Standaard posterpapier': '135 g/m² Gesatineerd mc',
    'Extra stevig posterpapier': '250 g/m² Gesatineerd mc',
    'Zijdeglans posterpapier': '170 g/m² Silk mc',
    'Premium zijdeglans posterpapier': '250 g/m² Silk mc',
    'Mat premium papier': '160 g/m² Premiumweiß ungestrichen',
    'Premium mat posterpapier': '230 g/m² Premium matt gestrichen',
    'Recht afgesneden': 'Gerade geschnitten',
    'Schoonsnijden': 'Gerade schneiden',
    'Contoursnijden (1 eenvoudige vorm)': 'Konturschnitt (1 einfache Form)',
    'Contoursnijden (1 complexe vorm)': 'Konturschnitt (1 komplexe Form)',
    'Geen afgeronde hoeken': 'Keine abgerundeten Ecken',
    'Geen boorgaten': 'Keine Bohrlöcher',
    '1 boorgat': '1 Bohrloch',
    '2 boorgaten': '2 Bohrlöcher',
    '3 boorgaten': '3 Bohrlöcher',
    '4 boorgaten': '4 Bohrlöcher',
    '5 boorgaten': '5 Bohrlöcher',
    '6 boorgaten': '6 Bohrlöcher',
    '7 boorgaten': '7 Bohrlöcher',
    '8 boorgaten': '8 Bohrlöcher',
    '9 boorgaten': '9 Bohrlöcher',
    '10 boorgaten': '10 Bohrlöcher',
    'Boorgaten in elke hoek (6 mm)': 'Bohrlöcher in jeder Ecke (6 mm)',
    'Boorgaten in elke hoek (8 mm)': 'Bohrlöcher in jeder Ecke (8 mm)',
    'Boorgaten in elke hoek (9 mm)': 'Bohrlöcher in jeder Ecke (9 mm)',
    'Boorgaten in elke hoek (10 mm)': 'Bohrlöcher in jeder Ecke (10 mm)',
    'Zonder passe-partout': 'Ohne Passepartout',
    'Passe-partout zwart': 'Passepartout schwarz',
    'Passe-partout wit': 'Passepartout weiß',
    'Passe-partout creme': 'Passepartout creme',
    'Hout zwart': 'Holz schwarz',
    'Hout wit': 'Holz weiß',
    'Hout naturel': 'Holz natur',
    'Aluminium zwart glans': 'Aluminium schwarz glaenzend',
    'Aluminium zwart mat': 'Aluminium schwarz matt',
    'Aluminium wit glans': 'Aluminium weiß glaenzend',
    'Aluminium goud glans': 'Aluminium gold glaenzend',
    'Aluminium goud mat': 'Aluminium gold matt',
    'Aluminium zilver glans': 'Aluminium silber glaenzend',
    'Aluminium zilver mat': 'Aluminium silber matt',
    'Aluminium rosegoud glans': 'Aluminium rosegold glaenzend',
    'Aluminium roségoud glans': 'Aluminium rosegold glaenzend',
    'Aluminium champagne glans': 'Aluminium champagner glaenzend',
    'Aluminium blauw mat': 'Aluminium blau matt',
    'Zonder extra beschermlaag. Goede keuze voor poster': 'Ohne zusaetzliche Schutzschicht. Gute Wahl für Poster.',
    'Zonder extra beschermlaag. Goede keuze voor posters achter glas of normaal binnengebruik.': 'Ohne zusätzliche Schutzschicht. Gute Wahl für Poster hinter Glas oder normale Nutzung im Innenbereich.',
    'Extra bescherming met glanzende uitstraling.': 'Zusätzlicher Schutz mit glänzender Optik.',
    'Extra bescherming met rustige matte uitstraling.': 'Zusätzlicher Schutz mit ruhiger matter Optik.',
    'Geen coating': 'Keine Beschichtung',
    'Geen beschermlaag': 'Keine Schutzschicht',
    'Glanzende beschermlaag': 'Glaenzende Schutzschicht',
    'Matte beschermlaag': 'Matte Schutzschicht',
    'Beschermende coating (glans)': 'Schutzbeschichtung glaenzend',
    'Beschermende coating (mat)': 'Schutzbeschichtung matt',
    'Oraguard® 215 (polymeer glans)': 'Oraguard® 215 glaenzend',
    'Oraguard® 215 (polymeer mat)': 'Oraguard® 215 matt',
    'Glanzende coating': 'Glaenzende Beschichtung',
    'Matte coating': 'Matte Beschichtung',
    'Standaard afwerking zonder extra beschermlaag.': 'Standardverarbeitung ohne zusaetzliche Schutzschicht.',
    'Geeft krachtigere kleuren en extra bescherming van': 'Sorgt für kräftigere Farben und zusätzlichen Schutz.',
    'Geeft een rustige matte uitstraling en extra besch': 'Sorgt für eine ruhige matte Optik und zusätzlichen Schutz.',
    'Mat textiel': 'Matter Stoff',
    'Gestructureerd textiel': 'Strukturierter Stoff',
    'Wit garen': 'Weißes Garn',
    'Zwart garen': 'Schwarzes Garn',
    'Horizontaal': 'Horizontal',
    'Verticaal': 'Vertikal',
    'De metaalstructuur loopt horizontaal door het ontw': 'Die Metallstruktur verläuft horizontal durch das Design.',
    'De metaalstructuur loopt verticaal door het ontwer': 'Die Metallstruktur verläuft vertikal durch das Design.',
    'Met stretchframe': 'Mit Spannrahmen',
    'Alleen print': 'Nur Druck',
    'Ja': 'Ja',
    'Nee': 'Nein',
    'Genummerde stroken': 'Nummerierte Bahnen',
    'Geen genummerde stroken': 'Keine nummerierten Bahnen',
    'Breedte x hoogte in centimeters.': 'Breite x Hoehe in Zentimetern.',
    'Voer zelf breedte en hoogte in.': 'Breite und Höhe selbst eingeben.',
    'Snellere productie: meestal ongeveer 2-4 werkdagen': 'Schnellere Produktion: meist ca. 2-4 Werktage.',
    'Normale productietijd: meestal ongeveer 4-6 werkda': 'Normale Produktionszeit: meist ca. 4-6 Werktage.',
    'Spoedproductie: meestal ongeveer 1-3 werkdagen voo': 'Expressproduktion: meist ca. 1-3 Werktage.',
    'Een dag eerder geproduceerd dan standaard: meestal': 'Einen Tag frueher als Standard produziert.',
    'Normale productietijd: meestal ongeveer 4-6 werkdagen voordat het product wordt verzonden.': 'Normale Produktionszeit: meist ca. 4-6 Werktage bis zum Versand.',
    'Een dag eerder geproduceerd dan standaard: meestal ongeveer 3-5 werkdagen voordat het product wordt verzonden.': 'Einen Tag früher als Standard produziert: meist ca. 3-5 Werktage bis zum Versand.',
    'Aantal posters.': 'Anzahl Poster.',
    'Aantal prints.': 'Anzahl Drucke.',
    'Niet schoonsnijden': 'Nicht gerade schneiden',
    'Type print': 'Druckart',
    'Kies het formaat van je poster. Van A4 tot 120 x 150 cm.': 'Wähle das Format deines Posters. Von A4 bis 120 x 150 cm.',
    'Kies standaard, extra stevig, fine-art of fotopapier.': 'Wähle Standard, extra stark, Fine-Art oder Fotopapier.',
    'Kies mat, glans of geen laminaat.': 'Wähle matt, glänzend oder kein Laminat.',
    'Kies mat of glans laminaat.': 'Wähle mattes oder glänzendes Laminat.',
    'Kies geen, 3,5 mm of 7 mm radius.': 'Wähle keine, 3,5 mm oder 7 mm Radius.',
    'Kies geborsteld aluminium, wit, goud, zilver of koper.': 'Wähle gebürstetes Aluminium, Weiß, Gold, Silber oder Kupfer.',
    'Vrij formaat van 15 x 20 tot 150 x 200 cm.': 'Freies Format von 15 x 20 bis 150 x 200 cm.',
    'Vrij formaat tot circa 200 x 300 cm.': 'Freies Format bis ca. 200 x 300 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 15 x 10 cm tot 201 x 145 cm.': 'Breite und Höhe selbst eingeben. Möglich von 15 x 10 cm bis 201 x 145 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 50 x 50 cm tot 2500 x 314 cm.': 'Breite und Höhe selbst eingeben. Möglich von 50 x 50 cm bis 2500 x 314 cm.',
    'Aluminium ophangprofiel of boorgaten.': 'Aluminium-Aufhängeprofil oder Bohrlöcher.',
    '4/0 Full colour (print op folie)': '4/0 Vollfarbdruck (Druck auf Folie)',
    '230 g/m2 Fotopapier glans': '230 g/m2 Fotopapier glaenzend',
    'Kies de buitenmaat van de baklijst. Het paneel zelf valt rondom iets kleiner in de lijst.': 'Wähle das Außenmaß des Rahmens. Das Panel selbst liegt rundum etwas kleiner im Rahmen.',
    'Kies de richting van de geborstelde metaalstructuur. Dit is alleen relevant bij geborsteld aluminium.': 'Wähle die Richtung der gebürsteten Metallstruktur. Dies ist nur bei gebürstetem Aluminium relevant.',
    'Een coating geeft extra bescherming en kan de uitstraling matter of juist glanzender maken.': 'Eine Beschichtung bietet zusätzlichen Schutz und kann die Optik matter oder glänzender machen.',
    'Geeft een rustige matte uitstraling en extra bescherming van het oppervlak.': 'Sorgt für eine ruhige matte Optik und zusätzlichen Oberflächenschutz.',
    'Standaard printzijde voor aluminium panelen.': 'Standard-Druckseite für Aluminiumpaneele.',
    'Kies de uitstraling van het doek. Mat textiel is rustig en strak, gestructureerd textiel heeft meer zichtbare textuur.': 'Wähle die Optik des Tuchs. Matter Stoff wirkt ruhig und glatt, strukturierter Stoff zeigt mehr Textur.',
    'Fijngeweven polyester met een rustige, matte uitstraling. Mooi voor foto’s, illustraties en strakke interieurposters.': 'Fein gewebtes Polyester mit ruhiger matter Optik. Schön für Fotos, Illustrationen und klare Interior-Poster.',
    'Kies een vaste breedte. Je kiest daarna zelf de hoogte van je textielposter.': 'Wähle eine feste Breite. Die Höhe deines Textilposters bestimmst du danach selbst.',
    'Vrije hoogte in centimeters. Vul zelf de gewenste hoogte in binnen de toegestane maatvoering.': 'Freie Höhe in Zentimetern. Gib die gewünschte Höhe innerhalb der erlaubten Masse ein.',
    'De tunnel boven en onder wordt afgewerkt met een stiknaad. Kies wit of zwart garen passend bij je ontwerp.': 'Der Tunnel oben und unten wird mit einer Naht verarbeitet. Wähle weißes oder schwarzes Garn passend zu deinem Design.',
  },
  en: {
    'Formaat (b x h)': 'Size (W x H)',
    'Papiersoort': 'Paper type',
    'Dikte': 'Thickness',
    'Dibond variant': 'Dibond variant',
    'Papier': 'Paper',
    'Stof': 'Fabric',
    'Breedte (cm)': 'Width (cm)',
    'Hoogte (cm)': 'Height (cm)',
    'Breedte per baan': 'Strip width',
    'Baanmarkering': 'Strip numbering',
    'Handleiding meeleveren': 'Include manual',
    'Aantal banen': 'Number of strips',
    'Aantal rollen': 'Number of rolls',
    'Productietijd': 'Production time',
    'Vorm': 'Shape',
    'Hoeken': 'Corners',
    'Afgeronde hoeken': 'Rounded corners',
    'Lijst': 'Frame',
    'Passe-partout': 'Mount',
    'Penseelrichting': 'Brush direction',
    'Coating': 'Coating',
    'coating': 'Coating',
    'Ophanging': 'Hanging',
    'Op maat': 'Custom size',
    'Standaard posterpapier': '135 g/m² satin coated paper',
    'Extra stevig posterpapier': '250 g/m² satin coated paper',
    'Zijdeglans posterpapier': '170 g/m² silk coated paper',
    'Premium zijdeglans posterpapier': '250 g/m² silk coated paper',
    'Mat premium papier': '160 g/m² premium bright white uncoated paper',
    'Premium mat posterpapier': '230 g/m² premium matt coated paper',
    '135 g/m² gesatineerd mc': '135 g/m² satin coated paper',
    '250 g/m² gesatineerd mc': '250 g/m² satin coated paper',
    '170 g/m² silk mc': '170 g/m² silk coated paper',
    '250 g/m² silk mc': '250 g/m² silk coated paper',
    '160 g/m² ongestreken premium hoogwit': '160 g/m² premium bright white uncoated paper',
    '230 g/m² mat gestreken premium': '230 g/m² premium matt coated paper',
    'Recht afgesneden': 'Straight cut',
    'Schoonsnijden': 'Straight cut',
    'Contoursnijden (1 eenvoudige vorm)': 'Contour cut (1 simple shape)',
    'Contoursnijden (1 complexe vorm)': 'Contour cut (1 complex shape)',
    'Geen': 'None',
    'Geen afgeronde hoeken': 'No rounded corners',
    'Geen boorgaten': 'No drill holes',
    '1 boorgat': '1 drill hole',
    '2 boorgaten': '2 drill holes',
    '3 boorgaten': '3 drill holes',
    '4 boorgaten': '4 drill holes',
    '5 boorgaten': '5 drill holes',
    '6 boorgaten': '6 drill holes',
    '7 boorgaten': '7 drill holes',
    '8 boorgaten': '8 drill holes',
    '9 boorgaten': '9 drill holes',
    '10 boorgaten': '10 drill holes',
    'Boorgaten in elke hoek (6 mm)': 'Drill holes in each corner (6 mm)',
    'Boorgaten in elke hoek (8 mm)': 'Drill holes in each corner (8 mm)',
    'Boorgaten in elke hoek (9 mm)': 'Drill holes in each corner (9 mm)',
    'Boorgaten in elke hoek (10 mm)': 'Drill holes in each corner (10 mm)',
    'Zonder passe-partout': 'Without mount',
    'Passe-partout zwart': 'Black mount',
    'Passe-partout wit': 'White mount',
    'Passe-partout creme': 'Cream mount',
    'Hout zwart': 'Black wood',
    'Hout wit': 'White wood',
    'Hout naturel': 'Natural wood',
    'Aluminium zwart glans': 'Gloss black aluminium',
    'Aluminium zwart mat': 'Matt black aluminium',
    'Aluminium wit glans': 'Gloss white aluminium',
    'Aluminium goud glans': 'Gloss gold aluminium',
    'Aluminium goud mat': 'Matt gold aluminium',
    'Aluminium zilver glans': 'Gloss silver aluminium',
    'Aluminium zilver mat': 'Matt silver aluminium',
    'Aluminium rosegoud glans': 'Gloss rose gold aluminium',
    'Aluminium roségoud glans': 'Gloss rose gold aluminium',
    'Aluminium champagne glans': 'Gloss champagne aluminium',
    'Aluminium blauw mat': 'Matt blue aluminium',
    'Zonder extra beschermlaag. Goede keuze voor poster': 'No extra protective layer. Good choice for posters.',
    'Zonder extra beschermlaag. Goede keuze voor posters achter glas of normaal binnengebruik.': 'No extra protective layer. Good choice for posters behind glass or normal indoor use.',
    'Extra bescherming met glanzende uitstraling.': 'Extra protection with a glossy look.',
    'Extra bescherming met rustige matte uitstraling.': 'Extra protection with a calm matte look.',
    'Geen coating': 'No coating',
    'Geen beschermlaag': 'No protective layer',
    'Glanzende beschermlaag': 'Gloss protective layer',
    'Matte beschermlaag': 'Matt protective layer',
    'Beschermende coating (glans)': 'Gloss protective coating',
    'Beschermende coating (mat)': 'Matt protective coating',
    'Oraguard® 215 (polymeer glans)': 'Oraguard® 215 polymer gloss',
    'Oraguard® 215 (polymeer mat)': 'Oraguard® 215 polymer matt',
    'Glanzende coating': 'Gloss coating',
    'Matte coating': 'Matt coating',
    'Standaard afwerking zonder extra beschermlaag.': 'Standard finish without extra protective layer.',
    'Geeft krachtigere kleuren en extra bescherming van': 'Adds stronger colours and extra protection.',
    'Geeft een rustige matte uitstraling en extra besch': 'Adds a calm matte look and extra protection.',
    'Mat textiel': 'Matt textile',
    'Gestructureerd textiel': 'Textured textile',
    'Wit garen': 'White thread',
    'Zwart garen': 'Black thread',
    'Horizontaal': 'Horizontal',
    'Verticaal': 'Vertical',
    'De metaalstructuur loopt horizontaal door het ontw': 'The metal grain runs horizontally through the design.',
    'De metaalstructuur loopt verticaal door het ontwer': 'The metal grain runs vertically through the design.',
    'Met stretchframe': 'With stretch frame',
    'Alleen print': 'Print only',
    'Ja': 'Yes',
    'Nee': 'No',
    'Genummerde stroken': 'Numbered strips',
    'Geen genummerde stroken': 'No numbered strips',
    'Breedte x hoogte in centimeters.': 'Width x height in centimetres.',
    'Voer zelf breedte en hoogte in.': 'Enter width and height yourself.',
    'Snellere productie: meestal ongeveer 2-4 werkdagen': 'Faster production: usually about 2-4 working days.',
    'Normale productietijd: meestal ongeveer 4-6 werkda': 'Normal production time: usually about 4-6 working days.',
    'Spoedproductie: meestal ongeveer 1-3 werkdagen voo': 'Rush production: usually about 1-3 working days.',
    'Een dag eerder geproduceerd dan standaard: meestal': 'Produced one day earlier than standard.',
    'Normale productietijd: meestal ongeveer 4-6 werkdagen voordat het product wordt verzonden.': 'Normal production time: usually about 4-6 working days before dispatch.',
    'Een dag eerder geproduceerd dan standaard: meestal ongeveer 3-5 werkdagen voordat het product wordt verzonden.': 'Produced one day earlier than standard: usually about 3-5 working days before dispatch.',
    'Aantal posters.': 'Number of posters.',
    'Aantal prints.': 'Number of prints.',
    'Niet schoonsnijden': 'Do not straight cut',
    'Type print': 'Print type',
    'Kies het formaat van je poster. Van A4 tot 120 x 150 cm.': 'Choose the size of your poster. From A4 to 120 x 150 cm.',
    'Kies standaard, extra stevig, fine-art of fotopapier.': 'Choose standard, extra sturdy, fine-art or photo paper.',
    'Kies mat, glans of geen laminaat.': 'Choose matt, gloss or no laminate.',
    'Kies mat of glans laminaat.': 'Choose matt or gloss laminate.',
    'Kies geen, 3,5 mm of 7 mm radius.': 'Choose no radius, 3.5 mm or 7 mm radius.',
    'Kies geborsteld aluminium, wit, goud, zilver of koper.': 'Choose brushed aluminium, white, gold, silver or copper.',
    'Vrij formaat van 15 x 20 tot 150 x 200 cm.': 'Custom size from 15 x 20 to 150 x 200 cm.',
    'Vrij formaat tot circa 200 x 300 cm.': 'Custom size up to approx. 200 x 300 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 15 x 10 cm tot 201 x 145 cm.': 'Enter width and height yourself. Possible from 15 x 10 cm to 201 x 145 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 50 x 50 cm tot 2500 x 314 cm.': 'Enter width and height yourself. Possible from 50 x 50 cm to 2500 x 314 cm.',
    'Aluminium ophangprofiel of boorgaten.': 'Aluminium hanging profile or drill holes.',
    '4/0 Full colour (print op folie)': '4/0 full colour (printed on film)',
    '230 g/m2 Fotopapier glans': '230 g/m2 gloss photo paper',
    'Kies de buitenmaat van de baklijst. Het paneel zelf valt rondom iets kleiner in de lijst.': 'Choose the outer frame size. The panel itself is slightly smaller inside the frame.',
    'Kies de richting van de geborstelde metaalstructuur. Dit is alleen relevant bij geborsteld aluminium.': 'Choose the direction of the brushed metal grain. This only applies to brushed aluminium.',
    'Een coating geeft extra bescherming en kan de uitstraling matter of juist glanzender maken.': 'A coating adds extra protection and can make the look more matt or more glossy.',
    'Geeft een rustige matte uitstraling en extra bescherming van het oppervlak.': 'Adds a calm matt look and extra surface protection.',
    'Standaard printzijde voor aluminium panelen.': 'Standard print side for aluminium panels.',
    'Kies de uitstraling van het doek. Mat textiel is rustig en strak, gestructureerd textiel heeft meer zichtbare textuur.': 'Choose the fabric look. Matt textile is calm and clean, textured textile has more visible texture.',
    'Fijngeweven polyester met een rustige, matte uitstraling. Mooi voor foto’s, illustraties en strakke interieurposters.': 'Finely woven polyester with a calm matt look. Good for photos, illustrations and clean interior posters.',
    'Kies een vaste breedte. Je kiest daarna zelf de hoogte van je textielposter.': 'Choose a fixed width. You then choose the height of your textile poster yourself.',
    'Vrije hoogte in centimeters. Vul zelf de gewenste hoogte in binnen de toegestane maatvoering.': 'Free height in centimetres. Enter the desired height within the allowed size range.',
    'De tunnel boven en onder wordt afgewerkt met een stiknaad. Kies wit of zwart garen passend bij je ontwerp.': 'The top and bottom tunnel are finished with stitching. Choose white or black thread to match your design.',
  },
  fr: {
    'Formaat (b x h)': 'Format (L x H)',
    'Papiersoort': 'Type de papier',
    'Dikte': 'Epaisseur',
    'Dibond variant': 'Variante Dibond',
    'Papier': 'Papier',
    'Stof': 'Tissu',
    'Breedte (cm)': 'Largeur (cm)',
    'Hoogte (cm)': 'Hauteur (cm)',
    'Breedte per baan': 'Largeur par bande',
    'Baanmarkering': 'Numerotation des bandes',
    'Handleiding meeleveren': 'Inclure la notice',
    'Aantal banen': 'Nombre de bandes',
    'Aantal rollen': 'Nombre de rouleaux',
    'Productietijd': 'Delai de production',
    'Vorm': 'Forme',
    'Hoeken': 'Coins',
    'Afgeronde hoeken': 'Coins arrondis',
    'Lijst': 'Cadre',
    'Passe-partout': 'Passe-partout',
    'Penseelrichting': 'Sens du brossage',
    'Coating': 'Revêtement',
    'coating': 'Revêtement',
    'Ophanging': 'Accrochage',
    'Op maat': 'Sur mesure',
    'Standaard posterpapier': 'Papier couché satiné 135 g/m²',
    'Extra stevig posterpapier': 'Papier couché satiné 250 g/m²',
    'Zijdeglans posterpapier': 'Papier couché soie 170 g/m²',
    'Premium zijdeglans posterpapier': 'Papier couché soie 250 g/m²',
    'Mat premium papier': 'Papier premium blanc non couché 160 g/m²',
    'Premium mat posterpapier': 'Papier premium couché mat 230 g/m²',
    '135 g/m² gesatineerd mc': 'Papier couché satiné 135 g/m²',
    '250 g/m² gesatineerd mc': 'Papier couché satiné 250 g/m²',
    '170 g/m² silk mc': 'Papier couché soie 170 g/m²',
    '250 g/m² silk mc': 'Papier couché soie 250 g/m²',
    '160 g/m² ongestreken premium hoogwit': 'Papier premium blanc non couché 160 g/m²',
    '230 g/m² mat gestreken premium': 'Papier premium couché mat 230 g/m²',
    'Recht afgesneden': 'Coupe droite',
    'Schoonsnijden': 'Coupe droite',
    'Contoursnijden (1 eenvoudige vorm)': 'Decoupe contour (1 forme simple)',
    'Contoursnijden (1 complexe vorm)': 'Decoupe contour (1 forme complexe)',
    'Geen': 'Aucun',
    'Geen afgeronde hoeken': 'Pas de coins arrondis',
    'Geen boorgaten': 'Sans trous',
    '1 boorgat': '1 trou',
    '2 boorgaten': '2 trous',
    '3 boorgaten': '3 trous',
    '4 boorgaten': '4 trous',
    '5 boorgaten': '5 trous',
    '6 boorgaten': '6 trous',
    '7 boorgaten': '7 trous',
    '8 boorgaten': '8 trous',
    '9 boorgaten': '9 trous',
    '10 boorgaten': '10 trous',
    'Boorgaten in elke hoek (6 mm)': 'Trous dans chaque coin (6 mm)',
    'Boorgaten in elke hoek (8 mm)': 'Trous dans chaque coin (8 mm)',
    'Boorgaten in elke hoek (9 mm)': 'Trous dans chaque coin (9 mm)',
    'Boorgaten in elke hoek (10 mm)': 'Trous dans chaque coin (10 mm)',
    'Zonder passe-partout': 'Sans passe-partout',
    'Passe-partout zwart': 'Passe-partout noir',
    'Passe-partout wit': 'Passe-partout blanc',
    'Passe-partout creme': 'Passe-partout creme',
    'Hout zwart': 'Bois noir',
    'Hout wit': 'Bois blanc',
    'Hout naturel': 'Bois naturel',
    'Aluminium zwart glans': 'Aluminium noir brillant',
    'Aluminium zwart mat': 'Aluminium noir mat',
    'Aluminium wit glans': 'Aluminium blanc brillant',
    'Aluminium goud glans': 'Aluminium or brillant',
    'Aluminium goud mat': 'Aluminium or mat',
    'Aluminium zilver glans': 'Aluminium argent brillant',
    'Aluminium zilver mat': 'Aluminium argent mat',
    'Aluminium rosegoud glans': 'Aluminium or rose brillant',
    'Aluminium roségoud glans': 'Aluminium or rose brillant',
    'Aluminium champagne glans': 'Aluminium champagne brillant',
    'Aluminium blauw mat': 'Aluminium bleu mat',
    'Zonder extra beschermlaag. Goede keuze voor poster': 'Sans couche de protection supplémentaire. Bon choix pour les affiches.',
    'Zonder extra beschermlaag. Goede keuze voor posters achter glas of normaal binnengebruik.': 'Sans couche de protection supplementaire. Bon choix pour affiches sous verre ou usage interieur normal.',
    'Extra bescherming met glanzende uitstraling.': 'Protection supplementaire avec aspect brillant.',
    'Extra bescherming met rustige matte uitstraling.': 'Protection supplementaire avec aspect mat sobre.',
    'Geen coating': 'Sans revêtement',
    'Geen beschermlaag': 'Sans couche de protection',
    'Glanzende beschermlaag': 'Couche de protection brillante',
    'Matte beschermlaag': 'Couche de protection mate',
    'Beschermende coating (glans)': 'Revêtement de protection brillant',
    'Beschermende coating (mat)': 'Revêtement de protection mat',
    'Oraguard® 215 (polymeer glans)': 'Oraguard® 215 polymere brillant',
    'Oraguard® 215 (polymeer mat)': 'Oraguard® 215 polymere mat',
    'Glanzende coating': 'Revêtement brillant',
    'Matte coating': 'Revêtement mat',
    'Standaard afwerking zonder extra beschermlaag.': 'Finition standard sans couche de protection supplementaire.',
    'Geeft krachtigere kleuren en extra bescherming van': 'Apporte des couleurs plus fortes et une protection supplémentaire.',
    'Geeft een rustige matte uitstraling en extra besch': 'Apporte un aspect mat sobre et une protection supplementaire.',
    'Mat textiel': 'Textile mat',
    'Gestructureerd textiel': 'Textile texture',
    'Wit garen': 'Fil blanc',
    'Zwart garen': 'Fil noir',
    'Horizontaal': 'Horizontal',
    'Verticaal': 'Vertical',
    'De metaalstructuur loopt horizontaal door het ontw': 'La structure metallique traverse le design horizontalement.',
    'De metaalstructuur loopt verticaal door het ontwer': 'La structure metallique traverse le design verticalement.',
    'Met stretchframe': 'Avec cadre tendu',
    'Alleen print': 'Impression seule',
    'Ja': 'Oui',
    'Nee': 'Non',
    'Genummerde stroken': 'Bandes numerotees',
    'Geen genummerde stroken': 'Sans bandes numerotees',
    'Breedte x hoogte in centimeters.': 'Largeur x hauteur en centimetres.',
    'Voer zelf breedte en hoogte in.': 'Saisissez vous-meme la largeur et la hauteur.',
    'Snellere productie: meestal ongeveer 2-4 werkdagen': 'Production plus rapide: environ 2-4 jours ouvrables.',
    'Normale productietijd: meestal ongeveer 4-6 werkda': 'Delai de production normal: environ 4-6 jours ouvrables.',
    'Spoedproductie: meestal ongeveer 1-3 werkdagen voo': 'Production express: environ 1-3 jours ouvrables.',
    'Een dag eerder geproduceerd dan standaard: meestal': 'Produit un jour plus tot que le standard.',
    'Normale productietijd: meestal ongeveer 4-6 werkdagen voordat het product wordt verzonden.': 'Delai de production normal: environ 4-6 jours ouvrables avant expedition.',
    'Een dag eerder geproduceerd dan standaard: meestal ongeveer 3-5 werkdagen voordat het product wordt verzonden.': 'Produit un jour plus tot que le standard: environ 3-5 jours ouvrables avant expedition.',
    'Aantal posters.': 'Nombre d affiches.',
    'Aantal prints.': 'Nombre d impressions.',
    'Niet schoonsnijden': 'Ne pas couper droit',
    'Type print': 'Type d impression',
    'Kies het formaat van je poster. Van A4 tot 120 x 150 cm.': 'Choisissez le format de votre affiche. De A4 a 120 x 150 cm.',
    'Kies standaard, extra stevig, fine-art of fotopapier.': 'Choisissez papier standard, extra rigide, fine-art ou photo.',
    'Kies mat, glans of geen laminaat.': 'Choisissez mat, brillant ou sans pelliculage.',
    'Kies mat of glans laminaat.': 'Choisissez pelliculage mat ou brillant.',
    'Kies geen, 3,5 mm of 7 mm radius.': 'Choisissez aucun rayon, 3,5 mm ou 7 mm.',
    'Kies geborsteld aluminium, wit, goud, zilver of koper.': 'Choisissez aluminium brosse, blanc, or, argent ou cuivre.',
    'Vrij formaat van 15 x 20 tot 150 x 200 cm.': 'Format libre de 15 x 20 a 150 x 200 cm.',
    'Vrij formaat tot circa 200 x 300 cm.': 'Format libre jusqu a environ 200 x 300 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 15 x 10 cm tot 201 x 145 cm.': 'Saisissez vous-meme largeur et hauteur. Possible de 15 x 10 cm a 201 x 145 cm.',
    'Voer zelf breedte en hoogte in. Mogelijk van 50 x 50 cm tot 2500 x 314 cm.': 'Saisissez vous-meme largeur et hauteur. Possible de 50 x 50 cm a 2500 x 314 cm.',
    'Aluminium ophangprofiel of boorgaten.': 'Profil de suspension aluminium ou trous de percage.',
    '4/0 Full colour (print op folie)': '4/0 quadrichromie (impression sur film)',
    '230 g/m2 Fotopapier glans': 'Papier photo brillant 230 g/m2',
    'Kies de buitenmaat van de baklijst. Het paneel zelf valt rondom iets kleiner in de lijst.': 'Choisissez la dimension extérieure du cadre. Le panneau est légèrement plus petit dans le cadre.',
    'Kies de richting van de geborstelde metaalstructuur. Dit is alleen relevant bij geborsteld aluminium.': 'Choisissez le sens de la structure metallique brossee. Cela concerne uniquement l aluminium brosse.',
    'Een coating geeft extra bescherming en kan de uitstraling matter of juist glanzender maken.': 'Un revetement ajoute une protection et peut rendre l aspect plus mat ou plus brillant.',
    'Geeft een rustige matte uitstraling en extra bescherming van het oppervlak.': 'Donne un aspect mat sobre et une protection supplementaire de la surface.',
    'Standaard printzijde voor aluminium panelen.': 'Face d impression standard pour panneaux aluminium.',
    'Kies de uitstraling van het doek. Mat textiel is rustig en strak, gestructureerd textiel heeft meer zichtbare textuur.': 'Choisissez l’aspect du tissu. Le textile mat est sobre et net, le textile texture montre plus de relief.',
    'Fijngeweven polyester met een rustige, matte uitstraling. Mooi voor foto’s, illustraties en strakke interieurposters.': 'Polyester finement tisse avec un aspect mat sobre. Idéal pour photos, illustrations et affiches intérieur nettes.',
    'Kies een vaste breedte. Je kiest daarna zelf de hoogte van je textielposter.': 'Choisissez une largeur fixe. Vous choisissez ensuite vous-même la hauteur de votre affiche textile.',
    'Vrije hoogte in centimeters. Vul zelf de gewenste hoogte in binnen de toegestane maatvoering.': 'Hauteur libre en centimetres. Saisissez la hauteur souhaitée dans les limites autorisees.',
    'De tunnel boven en onder wordt afgewerkt met een stiknaad. Kies wit of zwart garen passend bij je ontwerp.': 'Le tunnel en haut et en bas est fini par une couture. Choisissez fil blanc ou noir selon votre design.',
  },
};

const batch2WallDecorOptionTranslations: Record<string, Record<string, string>> = {
  de: {
    'Formaat (breedte x hoogte)': 'Format (Breite x Hoehe)',
    'Print type': 'Druckart',
    'Type print': 'Druckart',
    'Printmethode': 'Druckmethode',
    'Verpakking': 'Verpackung',
    'Type frame': 'Rahmentyp',
    'Kleur frame': 'Rahmenfarbe',
    'Wit': 'Weiß',
    'Zwart': 'Schwarz',
    'Naturel': 'Natur',
    'Bruin': 'Braun',
    'Donkergrijs': 'Dunkelgrau',
    'Lichtgrijs': 'Hellgrau',
    'Zilver': 'Silber',
    'Goud': 'Gold',
    'Witte deklaag': 'Weiße Deckschicht',
    'Volledig wit achter de foto': 'Vollflaechig weiß hinter dem Foto',
    'Geen witte deklaag': 'Keine weiße Deckschicht',
    'Achterzijde': 'Rueckseite',
    'Plexiglas dikte': 'Plexiglas-Staerke',
    'Kleurdekking': 'Farbdeckung',
    'Snij-afwerking': 'Schneideverarbeitung',
    'Contoursnijden eenvoudige vorm': 'Konturschnitt einfache Form',
    'Contoursnijden complexe vorm': 'Konturschnitt komplexe Form',
    'Extra achterzijde bescherming': 'Zusaetzlicher Rueckseitenschutz',
    'Geen blockout folie': 'Keine Blockout-Folie',
    'Boorgaten zelf aangeven in bestand': 'Bohrlöcher selbst in der Datei angeben',
    'Keramische tegel (wit glans)': 'Keramikfliese weiß glaenzend',
    'Keramische tegel (wit mat)': 'Keramikfliese weiß matt',
    'Materiaal doek': 'Tuchmaterial',
    'Frame met doek': 'Rahmen mit Tuch',
    'Alleen frame': 'Nur Rahmen',
    'Aantal panelen. Meerdere panelen nodig? Bestel een set of vraag een projectprijs aan.': 'Anzahl der Paneele. Brauchst du mehrere Paneele? Bestelle ein Set oder frage einen Projektpreis an.',
    'Basic paneel voor minder galm in kantoor, horeca of wachtruimte.': 'Basic-Paneel für weniger Hall in Büro, Gastronomie oder Wartebereich.',
    'Premium paneel voor ruimtes waar akoestiek en uitstraling extra belangrijk zijn.': 'Premium-Paneel für Räume, in denen Akustik und Optik besonders wichtig sind.',
    'Wit frame voor rustige, lichte interieurs en kantoren.': 'Weißer Rahmen für ruhige, helle Innenräume und Büros.',
    'Zwart frame voor meer contrast en een strakke projectuitstraling.': 'Schwarzer Rahmen für mehr Kontrast und eine klare Projektoptik.',
    'Aanbevolen voor foto op helder plexiglas. De witte laag maakt kleuren voller en voorkomt doorkijk.': 'Empfohlen für Fotos auf klarem Plexiglas. Die weiße Schicht macht Farben voller und verhindert Durchsicht.',
    'Zonder witte laag blijven lichte delen transparanter. Alleen kiezen als dat bewust de bedoeling is.': 'Ohne weiße Schicht bleiben helle Bereiche transparenter. Nur wählen, wenn dieser Effekt gewuenscht ist.',
    'De foto wordt aan de achterzijde geprint zodat het plexiglas voor extra diepte en bescherming zorgt.': 'Das Foto wird auf der Rückseite gedruckt, sodass das Plexiglas für Tiefe und Schutz sorgt.',
    'Meer dieptewerking en premium uitstraling; zwaarder en duurder dan 3 mm.': 'Mehr Tiefenwirkung und Premium-Optik; schwerer und teurer als 3 mm.',
    'Aanbevolen voor foto?s. Full colour print met 200% wit voor betere dekking en kleurkracht.': 'Empfohlen für Fotos. Vollfarbdruck mit 200% Weiß für bessere Deckung und Farbwirkung.',
    'Extra bescherming aan de achterzijde, vooral handig bij grotere panelen of intensiever gebruik.': 'Zusätzlicher Schutz auf der Rückseite, besonders sinnvoll bei größeren Paneelen oder intensiver Nutzung.',
    'Laat de achterzijde standaard. Geschikt voor normaal binnengebruik.': 'Standard-Rueckseite beibehalten. Geeignet für normale Innenanwendung.',
    'Gebruik deze optie als je boorgaten exact in je ontwerp wilt aangeven.': 'Waehle diese Option, wenn du Bohrlöcher exakt in deiner Datei markieren willst.',
    'Los bedrukte doek voor een bestaand houten textielframe.': 'Lose bedrucktes Tuch für einen bestehenden Holz-Textilrahmen.',
  },
  en: {
    'Formaat (breedte x hoogte)': 'Size (width x height)',
    'Print type': 'Print type',
    'Type print': 'Print type',
    'Printmethode': 'Print method',
    'Verpakking': 'Packaging',
    'Type frame': 'Frame type',
    'Kleur frame': 'Frame colour',
    'Wit': 'White',
    'Zwart': 'Black',
    'Naturel': 'Natural',
    'Bruin': 'Brown',
    'Donkergrijs': 'Dark grey',
    'Lichtgrijs': 'Light grey',
    'Zilver': 'Silver',
    'Goud': 'Gold',
    'Witte deklaag': 'White backing layer',
    'Volledig wit achter de foto': 'Full white backing behind the photo',
    'Geen witte deklaag': 'No white backing layer',
    'Achterzijde': 'Back side',
    'Plexiglas dikte': 'Plexiglas thickness',
    'Kleurdekking': 'Colour coverage',
    'Snij-afwerking': 'Cut finish',
    'Contoursnijden eenvoudige vorm': 'Contour cut simple shape',
    'Contoursnijden complexe vorm': 'Contour cut complex shape',
    'Extra achterzijde bescherming': 'Extra back-side protection',
    'Geen blockout folie': 'No blockout film',
    'Boorgaten zelf aangeven in bestand': 'Mark drill holes yourself in the file',
    'Keramische tegel (wit glans)': 'Ceramic tile, white gloss',
    'Keramische tegel (wit mat)': 'Ceramic tile, white matt',
    'Materiaal doek': 'Fabric material',
    'Frame met doek': 'Frame with fabric',
    'Alleen frame': 'Frame only',
    'Aantal panelen. Meerdere panelen nodig? Bestel een set of vraag een projectprijs aan.': 'Number of panels. Need multiple panels? Order a set or request a project price.',
    'Basic paneel voor minder galm in kantoor, horeca of wachtruimte.': 'Basic panel for less echo in offices, hospitality spaces or waiting rooms.',
    'Premium paneel voor ruimtes waar akoestiek en uitstraling extra belangrijk zijn.': 'Premium panel for rooms where acoustics and appearance matter most.',
    'Wit frame voor rustige, lichte interieurs en kantoren.': 'White frame for calm, light interiors and offices.',
    'Zwart frame voor meer contrast en een strakke projectuitstraling.': 'Black frame for more contrast and a clean project look.',
    'Aanbevolen voor foto op helder plexiglas. De witte laag maakt kleuren voller en voorkomt doorkijk.': 'Recommended for photos on clear plexiglass. The white layer makes colours fuller and prevents transparency.',
    'Zonder witte laag blijven lichte delen transparanter. Alleen kiezen als dat bewust de bedoeling is.': 'Without a white layer, light areas stay more transparent. Choose this only if you want that effect.',
    'De foto wordt aan de achterzijde geprint zodat het plexiglas voor extra diepte en bescherming zorgt.': 'The photo is printed on the back so the plexiglass adds depth and protection.',
    'Meer dieptewerking en premium uitstraling; zwaarder en duurder dan 3 mm.': 'More depth and a premium look; heavier and more expensive than 3 mm.',
    'Aanbevolen voor foto?s. Full colour print met 200% wit voor betere dekking en kleurkracht.': 'Recommended for photos. Full colour print with 200% white for better coverage and colour strength.',
    'Extra bescherming aan de achterzijde, vooral handig bij grotere panelen of intensiever gebruik.': 'Extra protection on the back, especially useful for larger panels or heavier use.',
    'Laat de achterzijde standaard. Geschikt voor normaal binnengebruik.': 'Keep the back side standard. Suitable for normal indoor use.',
    'Gebruik deze optie als je boorgaten exact in je ontwerp wilt aangeven.': 'Use this option if you want to mark drill holes exactly in your design file.',
    'Los bedrukte doek voor een bestaand houten textielframe.': 'Loose printed fabric for an existing wooden textile frame.',
  },
  fr: {
    'Formaat (breedte x hoogte)': 'Format (largeur x hauteur)',
    'Print type': 'Type d impression',
    'Type print': 'Type d impression',
    'Printmethode': 'Methode d impression',
    'Verpakking': 'Emballage',
    'Type frame': 'Type de cadre',
    'Kleur frame': 'Couleur du cadre',
    'Wit': 'Blanc',
    'Zwart': 'Noir',
    'Naturel': 'Naturel',
    'Bruin': 'Brun',
    'Donkergrijs': 'Gris fonce',
    'Lichtgrijs': 'Gris clair',
    'Zilver': 'Argent',
    'Goud': 'Or',
    'Witte deklaag': 'Sous-couche blanche',
    'Volledig wit achter de foto': 'Blanc complet derriere la photo',
    'Geen witte deklaag': 'Pas de sous-couche blanche',
    'Achterzijde': 'Verso',
    'Plexiglas dikte': 'Epaisseur du plexiglas',
    'Kleurdekking': 'Couverture couleur',
    'Snij-afwerking': 'Finition de decoupe',
    'Contoursnijden eenvoudige vorm': 'Decoupe contour forme simple',
    'Contoursnijden complexe vorm': 'Decoupe contour forme complexe',
    'Extra achterzijde bescherming': 'Protection supplementaire au verso',
    'Geen blockout folie': 'Pas de film occultant',
    'Boorgaten zelf aangeven in bestand': 'Indiquer les trous de percage dans le fichier',
    'Keramische tegel (wit glans)': 'Carreau ceramique blanc brillant',
    'Keramische tegel (wit mat)': 'Carreau ceramique blanc mat',
    'Materiaal doek': 'Matiere de la toile',
    'Frame met doek': 'Cadre avec toile',
    'Alleen frame': 'Cadre seul',
    'Aantal panelen. Meerdere panelen nodig? Bestel een set of vraag een projectprijs aan.': 'Nombre de panneaux. Besoin de plusieurs panneaux ? Commandez un lot ou demandez un prix projet.',
    'Basic paneel voor minder galm in kantoor, horeca of wachtruimte.': 'Panneau Basic pour reduire la reverberation dans un bureau, un espace horeca ou une salle d’attente.',
    'Premium paneel voor ruimtes waar akoestiek en uitstraling extra belangrijk zijn.': 'Panneau Premium pour les espaces ou acoustique et aspect sont essentiels.',
    'Wit frame voor rustige, lichte interieurs en kantoren.': 'Cadre blanc pour interieurs et bureaux clairs et sobres.',
    'Zwart frame voor meer contrast en een strakke projectuitstraling.': 'Cadre noir pour plus de contraste et un rendu projet net.',
    'Aanbevolen voor foto op helder plexiglas. De witte laag maakt kleuren voller en voorkomt doorkijk.': 'Recommande pour les photos sur plexiglas transparent. La couche blanche renforce les couleurs et evite la transparence.',
    'Zonder witte laag blijven lichte delen transparanter. Alleen kiezen als dat bewust de bedoeling is.': 'Sans couche blanche, les zones claires restent plus transparentes. A choisir uniquement si cet effet est souhaite.',
    'De foto wordt aan de achterzijde geprint zodat het plexiglas voor extra diepte en bescherming zorgt.': 'La photo est imprimée au verso pour que le plexiglas apporte profondeur et protection.',
    'Meer dieptewerking en premium uitstraling; zwaarder en duurder dan 3 mm.': 'Plus de profondeur et un rendu premium; plus lourd et plus cher que 3 mm.',
    'Aanbevolen voor foto?s. Full colour print met 200% wit voor betere dekking en kleurkracht.': 'Recommande pour les photos. Impression quadrichromie avec 200% de blanc pour une meilleure opacite et couleur.',
    'Extra bescherming aan de achterzijde, vooral handig bij grotere panelen of intensiever gebruik.': 'Protection supplémentaire au verso, utile surtout pour les grands panneaux ou un usage plus intensif.',
    'Laat de achterzijde standaard. Geschikt voor normaal binnengebruik.': 'Conserver le verso standard. Convient a un usage interieur normal.',
    'Gebruik deze optie als je boorgaten exact in je ontwerp wilt aangeven.': 'Utilisez cette option si vous voulez indiquer precisement les trous dans votre fichier.',
    'Los bedrukte doek voor een bestaand houten textielframe.': 'Toile imprimee seule pour un cadre textile bois existant.',
  },
};

export function translatePrintLabel(label: string, locale: string = 'nl'): string {
  const lang = locale.split('-')[0];
  const translations = printLabelTranslations[lang] || printLabelTranslations.nl;
  const wallDecorTranslations = {
    ...(wallDecorOptionTranslations[lang] || {}),
    ...(batch2WallDecorOptionTranslations[lang] || {}),
  };
  const normalized = label?.trim();
  if (!normalized) return label;
  const generatedLabel = derivedOptionLabel(normalized, locale);
  if (generatedLabel) return generatedLabel;

  if (lang === 'de') {
    if (/^Rond\s+Ø/i.test(normalized)) return normalized.replace(/^Rond/i, 'Rund');
    if (/^(\d+(?:[,.]\d+)?)\s*mm\s+vierkant$/i.test(normalized)) return normalized.replace(/vierkant$/i, 'quadratisch');
  }
  if (lang === 'fr') {
    if (/^Rond\s+Ø/i.test(normalized)) return normalized.replace(/^Rond/i, 'Rond');
    if (/^(\d+(?:[,.]\d+)?)\s*mm\s+vierkant$/i.test(normalized)) return normalized.replace(/vierkant$/i, 'carré');
  }
  if (lang === 'en') {
    if (/^Rond\s+Ø/i.test(normalized)) return normalized.replace(/^Rond/i, 'Round');
    if (/^(\d+(?:[,.]\d+)?)\s*mm\s+vierkant$/i.test(normalized)) return normalized.replace(/vierkant$/i, 'square');
  }

  if (lang !== 'nl') {
    const squareSizeMatch = normalized.match(/^Vierkant\s+(\d+(?:[,.]\d+)?\s*x\s*\d+(?:[,.]\d+)?\s*cm)$/i);
    if (squareSizeMatch) {
      const shape = lang === 'de' ? 'Quadratisch' : lang === 'fr' ? 'Carre' : 'Square';
      return `${shape} ${squareSizeMatch[1]}`;
    }

    const orientationMatch = normalized.match(/^(\d+\s*x\s*\d+\s*cm)\s+(staand|liggend)$/i);
    if (orientationMatch) {
      const orientation = orientationMatch[2].toLowerCase() === 'staand'
        ? (lang === 'de' ? 'Hochformat' : lang === 'fr' ? 'portrait' : 'portrait')
        : (lang === 'de' ? 'Querformat' : lang === 'fr' ? 'paysage' : 'landscape');
      return `${orientationMatch[1]} ${orientation}`;
    }
  }

  return wallDecorTranslations[normalized] || translations[normalized] || normalized || label;
}
